import type {
  PersonalizedDiscountToken,
  SelectedDiscount,
  SelectedDiscount_NoPersonalizedDiscount,
} from "../../../../aysa_api/features/discount/v1/discount.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBasePersonalizedDiscountToken =
  (): PersonalizedDiscountToken => {
    return {
      token: "",
    };
  };

export const decodePersonalizedDiscountToken = (
  reader: Reader,
  length: number
): PersonalizedDiscountToken => {
  const end = reader.pos + length;
  const message = createBasePersonalizedDiscountToken();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.token = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePersonalizedDiscountToken = (
  writer: Writer,
  message: PersonalizedDiscountToken
): Writer => {
  writer.uint32(10).string(message.token);

  return writer;
};

export const createBaseSelectedDiscount = (): SelectedDiscount => {
  return {};
};

export const decodeSelectedDiscount = (
  reader: Reader,
  length: number
): SelectedDiscount => {
  const end = reader.pos + length;
  const message = createBaseSelectedDiscount();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = {
          $case: "noDiscount",
          noDiscount: decodeSelectedDiscount_NoPersonalizedDiscount(
            reader,
            reader.uint32()
          ),
        };

        break;
      case 2:
        message.type = {
          $case: "discount",
          discount: decodePersonalizedDiscountToken(reader, reader.uint32()),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSelectedDiscount = (
  writer: Writer,
  message: SelectedDiscount
): Writer => {
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "noDiscount":
        encodeSelectedDiscount_NoPersonalizedDiscount(
          writer.uint32(10).fork(),
          message.type.noDiscount
        ).ldelim();

        break;
      case "discount":
        encodePersonalizedDiscountToken(
          writer.uint32(18).fork(),
          message.type.discount
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseSelectedDiscount_NoPersonalizedDiscount =
  (): SelectedDiscount_NoPersonalizedDiscount => {
    return {};
  };

export const decodeSelectedDiscount_NoPersonalizedDiscount = (
  reader: Reader,
  length: number
): SelectedDiscount_NoPersonalizedDiscount => {
  const end = reader.pos + length;
  const message = createBaseSelectedDiscount_NoPersonalizedDiscount();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSelectedDiscount_NoPersonalizedDiscount = (
  writer: Writer,
  _message: SelectedDiscount_NoPersonalizedDiscount
): Writer => {
  return writer;
};
